import { LoginQuestionTypeDTO } from '@/api/account-controller/DTOs';
import { QuestionType } from '@/forms/typings';

export const adaptQuestionTypeToLoginQuestionType = (
  questionType: QuestionType,
): LoginQuestionTypeDTO => {
  switch (questionType) {
    case QuestionType.Unknown:
      return LoginQuestionTypeDTO.Unknown;
    case QuestionType.FirstName:
      return LoginQuestionTypeDTO.FirstName;
    case QuestionType.LastName:
      return LoginQuestionTypeDTO.LastName;
    case QuestionType.NPI:
      return LoginQuestionTypeDTO.NPI;
    case QuestionType.SSNLast4Digits:
      return LoginQuestionTypeDTO.SSNLast4Digits;
    case QuestionType.DOB:
      return LoginQuestionTypeDTO.DOB;
  }
};
